export type LineConditionRagBandSlug = 'red' | 'amber' | 'green';

export interface LineConditionRagBand {
  readonly slug: LineConditionRagBandSlug;
  readonly label: string;
  readonly min: number;
  readonly max: number;
  readonly color: string;
}

export const LINE_CONDITION_RAG_BANDS: readonly LineConditionRagBand[] = [
  { slug: 'red', label: 'Red', min: 0, max: 0.39, color: '#ff0000' },
  { slug: 'amber', label: 'Amber', min: 0.4, max: 0.69, color: '#ffbc00' },
  { slug: 'green', label: 'Green', min: 0.7, max: 1, color: '#65fa00' },
] as const;

export const LINE_CONDITION_RAG_COLOR_SCHEME = {
  min: LINE_CONDITION_RAG_BANDS[0].color,
  max: LINE_CONDITION_RAG_BANDS[2].color,
} as const;

export const LINE_CONDITION_RAG_THRESHOLDS = [0.4, 0.7, 1] as const;

export const LINE_CONDITION_RAG_THRESHOLD_ATTRIBUTE = 'Condition';

export const LINE_CONDITION_RAG_LEGEND_ITEMS = [
  { color: LINE_CONDITION_RAG_BANDS[2].color, label: '0.7–1' },
  { color: LINE_CONDITION_RAG_BANDS[1].color, label: '0.4–0.69' },
  { color: LINE_CONDITION_RAG_BANDS[0].color, label: '0–0.39' },
] as const;
